module.exports = __webpack_public_path__ + "img/swap-theta.4382d2e0.svg";